import { Video } from "@tamagui/lucide-icons";
import { useContext } from "react";

import {
  Button,
  Card,
  Heading,
  LayoutContext,
  Text,
  YStack,
  getTokenValue,
} from "@/components";
import Logo from "@/components/Logo";
import { getShadow } from "@/theme/helpers";
import VideoPreview from "./VideoPreview";

const StartVideoVisit = ({
  curaiConversationId,
}: {
  curaiConversationId: string;
}) => {
  const { setModalContent } = useContext(LayoutContext);

  const handleStartVideoVisit = () => {
    setModalContent(() => ({ onClose }: { onClose: () => void }) => (
      <VideoPreview
        onClose={onClose}
        curaiConversationId={curaiConversationId}
      />
    ));
  };

  return (
    <YStack
      width="100%"
      borderRadius="$150"
      maxWidth={
        getTokenValue("$constraint") + 2 * getTokenValue("$screenPadding")
      }
      alignSelf="center"
      marginBottom="$300"
      paddingHorizontal="$screenPadding"
    >
      <Card
        maxWidth="$constraint"
        width="100%"
        flexDirection="row"
        gap="$200"
        padding="$300"
        backgroundColor="$fillCallout"
        {...getShadow()}
        alignSelf="center"
        borderRadius="$150"
      >
        <Logo.Only />
        <YStack flex={1}>
          <Heading>Join your video visit</Heading>
          <Text size="$sm" marginBottom="$150">
            Your clinician is ready for you!
          </Text>
          <Button.Wrapper
            backgroundColor="$fillButtonPrimary"
            borderRadius="$150"
            gap="$100"
            paddingHorizontal="$200"
            paddingVertical="$100"
            alignItems="center"
            justifyContent="center"
            onPress={handleStartVideoVisit}
            color="$textButtonPrimary"
            alignSelf="flex-start"
          >
            <Video color="$textButtonPrimary" flexShrink={0} />
            <Text color="$textButtonPrimary">Join now</Text>
          </Button.Wrapper>
        </YStack>
      </Card>
    </YStack>
  );
};

export default StartVideoVisit;
